// @flow
import type { FavouritePlace } from 'mz-sdk/api_types'
import client from '../../client'
import getAuthorizedUserId from '../user/getAuthorizedUserId'
import format from '../../utils/format'

// Types

// API Endpoinds
export const USER_FAVOURITE_PLACES_ENDPOINT = '/auth/users/{0}/favorites/'

export const getAll = (): Promise<Array<FavouritePlace>> => {
  const userId = getAuthorizedUserId()
  const endpoint = format(USER_FAVOURITE_PLACES_ENDPOINT, userId)

  return client.get(endpoint)
}

export default getAll
